import { LitElement, html, svg } from 'lit';

export class IconPin16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Kartnål</title><path fill="currentColor" fill-rule="evenodd" d="M8.222 16C6.89 16 2 10.667 2 6.222a6.222 6.222 0 1 1 12.444 0c0 4.445-4.888 9.778-6.222 9.778Zm0-7.556a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444Z" clip-rule="evenodd"></path></svg>`; }
}
if (!customElements.get('f-icon-pin16', IconPin16)) {
  customElements.define('f-icon-pin16', IconPin16);
}